import React from 'react';
import { ProductDetail } from '../../types/api';

interface GameInfoProps {
  productDetail: ProductDetail;
}

const GameInfo: React.FC<GameInfoProps> = ({ productDetail }) => {
  const getPlaceholderImage = (title: string) => {
    const colors = ['1e40af', 'dc2626', 'f59e0b', '8b5cf6', 'ef4444', '0891b2'];
    const colorIndex = title.length % colors.length;
    return `https://via.placeholder.com/150x150/${colors[colorIndex]}/ffffff?text=${encodeURIComponent(title.substring(0, 3))}`;
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="flex gap-4 items-start">
        {/* Game Image */}
        <div className="flex-shrink-0">
          <img
            src={productDetail.logoUrl || getPlaceholderImage(productDetail.title)}
            alt={productDetail.title}
            className="w-24 h-24 md:w-32 md:h-32 rounded-lg object-cover shadow-sm"
            onError={(e) => {
              (e.target as HTMLImageElement).src = getPlaceholderImage(productDetail.title);
            }}
          />
        </div>

        {/* Game Title & Description */}
        <div className="flex-1">
          <h1 className="text-xl md:text-2xl font-bold text-gray-800 mb-2">
            {productDetail.titleEn || productDetail.title}
          </h1>
          {(productDetail.descriptionEn || productDetail.i18n?.instructionTextEn || productDetail.userInput?.instructionText) ? (
            <div className="text-sm md:text-base text-gray-600 leading-relaxed space-y-2 whitespace-pre-line">
              {(productDetail.descriptionEn) && (
                <p>{productDetail.descriptionEn}</p>
              )}
              {(productDetail.i18n?.instructionTextEn || productDetail.userInput?.instructionText) && (
                <p>{productDetail.i18n?.instructionTextEn || productDetail.userInput?.instructionText}</p>
              )}
            </div>
          ) : (
            <p className="text-sm md:text-base text-gray-600 leading-relaxed">
              {`Top up your ${productDetail.titleEn || productDetail.title} account now!`}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default GameInfo;
